export const notesFields = [
  {
    fieldName: 'note',
    fieldTitle: 'Add Note',
    fieldType: 'textarea',
    validationObj: {
      required: 'Please Enter Note',
    },
  },
  {
    fieldName: 'status',
    fieldTitle: 'Note Type',
    fieldType: 'select',
    validationObj: {
      required: 'Please Select Note Type',
    },
    options: [
      { label: 'Backlog', value: 'backlog' },
      { label: 'Addressed', value: 'addressed' },
      { label: 'Rejected', value: 'rejected' },
      { label: 'Resolved', value: 'resolved' },
    ],
  },
  {
    fieldName: 'fileUpload',
    fieldTitle: 'Upload File',
    fieldType: 'upload',
  },
];

export const ttdNoteFields = [
  {
    fieldName: 'note',
    fieldTitle: 'Add Note',
    fieldType: 'textarea',
    validationObj: {
      required: 'Please Enter Note',
    },
  },
  {
    fieldName: 'status',
    fieldTitle: 'Note Type',
    fieldType: 'select',
    validationObj: {
      required: 'Please Select Note Type',
    },
    options: [
      { label: 'Backlog', value: 'backlog' },
      { label: 'Approved', value: 'approved' },
    ],
  },
  {
    fieldName: 'fileUpload',
    fieldTitle: 'Upload File',
    fieldType: 'upload',
  },
];
export const dataEntryNotesFields = [
  {
    fieldName: 'fileUpload',
    fieldTitle: 'Upload File',
    fieldType: 'upload',
  },
];
